module.exports = __webpack_public_path__ + "img/dakar-sacre-coeur-nouveau-logo.dd97f146.jpg";